import React from 'react';
import { Row } from 'reactstrap';
import { Fade } from 'react-reveal';

const Current = () => {
    return (
        <React.Fragment>
            <Row className='mt-3'>
                <Fade delay={800}>
                    <h2 className='project-text' style={{fontWeight: '400'}}>Currently Working On?</h2>
                </Fade>
                <Fade bottom delay={800}>
                    <h3 className='text'> In my spare time, I continue to learn by building fullstack <span className='text-primary'>Spring Boot</span>, <span className='text-primary'>Node Js</span> and <span className='text-primary'>Python</span> applications. </h3>
                </Fade>
            </Row>
        </React.Fragment>
    )
}

export default Current;